/**
 * Created by Ning Jiang on 10/29/2019.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class DeadwoodGameMode extends GameMode{
    public static readonly FREESPIN_GUNSLINGER:string = "FREESPIN_GUNSLINGER";
    public static readonly FREESPIN_HUNTERS:string = "FREESPIN_HUNTERS";
    public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";
}